import {memo } from 'react';

import { Text, Icon, Box } from '@betty/moonlight';

import LandingCarousel from './LandingCarousel';
import {
  MostPopular,
  Classic,
  Jackpots,
} from './LandingCarouselProps.constants';
import { Link } from 'react-router';

function LandingCarouselSection() {

  return (
    <Box gap='space-600'>
      <Link to="/all">
          <Text variant="h4" gradient="darkSurfaceAccent">
            Choose from thousands of{' '}
            <span className="inline-item">
              slot games{' '}
              <Icon gradient="accentBackground" name="arrowForwardIosOutlined" />
            </span>
          </Text>
      </Link>
      <Box
        padding={{
          desktop: 'space-1000',
          tablet: 'space-400',
          mobile: 'space-400',
        }}
        gap={{
          desktop: 'space-1000',
          tablet: 'space-600',
          mobile: 'space-600',
        }}
        borderRadius="radius-400"
        backgroundColor="primaryBackground"
      >
        <LandingCarousel
          items={MostPopular}
          category="Most popular in Ontario"
        />
        <LandingCarousel
          items={Jackpots}
          category="Progressive jackpot slots"
        />
        <LandingCarousel items={Classic} category="Classic slots" />
      </Box>
    </Box>
  );
}

export default memo(LandingCarouselSection);
